export default __webpack_public_path__ + "static/media/bg.2fd3fbf9.png";